'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { getRecentCalculators, RecentCalculator } from '@/lib/recentCalculators';

interface RecentCalculatorsProps {
  limit?: number;
  title?: string;
}

// Icon colors for visual variety
const iconColors = [
  'bg-blue-500',
  'bg-green-500',
  'bg-purple-500',
  'bg-orange-500',
  'bg-pink-500',
  'bg-teal-500',
  'bg-indigo-500',
  'bg-red-500',
  'bg-yellow-500',
  'bg-cyan-500',
];

export default function RecentCalculators({ limit = 10, title = 'Recently Used' }: RecentCalculatorsProps) {
  const [recent, setRecent] = useState<RecentCalculator[]>([]);

  useEffect(() => {
    const calculators = getRecentCalculators().slice(0, limit);
    setRecent(calculators);
  }, [limit]);

  if (recent.length === 0) return null;

  return (
    <div className="mb-3">
      <h3 className="font-bold text-sm mb-2">{title}</h3>
      <div className="space-y-1.5 text-sm">
        {recent.map((calc, index) => (
          <Link
            key={calc.path}
            href={calc.path}
            className="flex items-center gap-2 text-blue-600 hover:underline group"
          >
            <span className={`w-2 h-2 rounded-full flex-shrink-0 ${iconColors[index % iconColors.length]}`}></span>
            <span className="group-hover:text-blue-800">{calc.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}